/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum QuestDisplay {
    GAMES = 'GAMES',
    CHALLENGES = 'CHALLENGES',
    GUILDS = 'GUILDS',
    LEADERBOARDS = 'LEADERBOARDS'
}

export function QuestDisplayFromJSON(json: any): QuestDisplay {
    return QuestDisplayFromJSONTyped(json, false);
}

export function QuestDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestDisplay {
    return json as QuestDisplay;
}

export function QuestDisplayToJSON(value?: QuestDisplay | null): any {
    return value as any;
}

